// Curated timezone choices for the signup wizard (and eventually the
// settings page). Values are IANA names — what parishes.timezone
// stores and every formatter consumes. US-centric on purpose: that's
// where MSP parishes are.

export interface TimezoneOption {
  value: string;
  label: string;
}

export const US_TIMEZONES: TimezoneOption[] = [
  { value: "America/New_York", label: "Eastern" },
  { value: "America/Chicago", label: "Central" },
  { value: "America/Denver", label: "Mountain" },
  { value: "America/Phoenix", label: "Arizona (no DST)" },
  { value: "America/Los_Angeles", label: "Pacific" },
  { value: "America/Anchorage", label: "Alaska" },
  { value: "Pacific/Honolulu", label: "Hawaii" },
];

// The browser's own zone, when it can be read. Coordinators sign up
// from the parish office, so this is almost always the right answer.
export function detectTimezone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? null;
  } catch {
    return null;
  }
}

// Options for the wizard select: the curated list, with the detected
// zone prepended when it isn't already one of them (e.g.
// America/Indiana/Indianapolis) so the default choice is still the
// coordinator's actual zone, not an approximation.
export function timezoneOptions(): { options: TimezoneOption[]; initial: string } {
  const detected = detectTimezone();
  if (detected && !US_TIMEZONES.some((o) => o.value === detected)) {
    return {
      options: [{ value: detected, label: `${detected} (detected)` }, ...US_TIMEZONES],
      initial: detected,
    };
  }
  return {
    options: US_TIMEZONES,
    initial: detected ?? "America/New_York",
  };
}
